import { render, staticRenderFns } from "./BrochuresStatistics.vue?vue&type=template&id=abb018c2&scoped=true&"
import script from "./BrochuresStatistics.vue?vue&type=script&lang=js&"
export * from "./BrochuresStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=abb018c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb018c2",
  null
  
)

export default component.exports